
import { defineComponent, onMounted, reactive, watch } from "vue";
import { useI18n } from "vue-i18n";
import { location } from "@/utils/default-data";
import { computed } from "@vue/reactivity";
import { Language, selectedLocale } from "@/locales/i18n";
export default defineComponent({
  props: {
    data: {
      type: Object,
    },
    display: {
      type: Array,
      default: () => [
        "image",
        "name",
        "description",
        "infoList",
        "linkList",
        "location",
      ],
    },
    display_left: {
      type: Array,
      default: () => ["name", "description", "accordion", "linkList"],
    },
    compact: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {
    const { t } = useI18n();
    const state = reactive({
      image: require("@/assets/images/slide-2.jpg"),
      userGroupIndex: -1,
      locationData: {
        lat: location.lat,
        lng: location.lng,
      },
      researchInfrastructureParts: {
        entity: t(
          "content.researchInfrastructure.content.headOfResearchEntityTitle"
        ),
        groups: t("content.researchInfrastructure.content.researchGroupsTitle"),
        listOfEquipment: t(
          "content.researchInfrastructure.content.listOfEquipment"
        ),
        organization: t(
          "content.researchInfrastructure.content.memberOfTheUniversityOfMariborTitle"
        ),
        location: t("content.researchInfrastructure.content.locationTitle"),
      },
    });

    onMounted(() => {
      setPreviewLocation();
    });

    const displayContains = (el: any) => {
      return props.display.indexOf(el) > -1;
    };

    const displayLeftContains = (el: any) => {
      return props.display_left.indexOf(el) > -1;
    };
    const toggleGroupUsers = (index: number) => {
      if (state.userGroupIndex == index) {
        state.userGroupIndex = -1;
      } else {
        state.userGroupIndex = index;
      }
    };

    watch(
      () => props.data?.id,
      () => {
        setPreviewLocation();
      }
    );

    function setPreviewLocation() {
      state.locationData = {
        lat: props.data?.location.latitude || location.lat,
        lng: props.data?.location.longitude || location.lng,
      } as any;
    }

    return {
      t,
      state,
      displayContains,
      displayLeftContains,
      toggleGroupUsers,
      defaultLanguageSelected: computed(() => selectedLocale() === Language.sl),
    };
  },
});
